<app-header></app-header>
<app-mobile-header></app-mobile-header>
<div class="w-100 text-center container">
    <div class="content">
    <h2 class="display-2">Ups... 404</h2>
    <p class="text">El sitio que buscas no existe. Por favor vuelve a la página principal. <a href="/">Volver</a></p>
</div>
</div>
